import { render } from "./Project.vue?vue&type=template&id=452754c9"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"
script.render = render

export default script